import React from 'react';
import { User } from 'lucide-react';
import { getVisitTypeColor } from './schedulingConstants';

export function VisitCard({ entry, onClick }) {
  return (
    <div
      className={`p-2 rounded-lg border text-xs cursor-pointer hover:shadow-md transition-shadow ${getVisitTypeColor(entry.visit_type)}`}
      onClick={() => onClick(entry)}
      data-testid={`visit-${entry.id}`}
    >
      <div className="flex items-center justify-between mb-1">
        <span className="font-semibold">{entry.start_time} - {entry.end_time}</span>
        {entry.status !== 'scheduled' && (
          <span className={`w-2 h-2 rounded-full ${
            entry.status === 'completed' ? 'bg-green-500' :
            entry.status === 'in_progress' ? 'bg-blue-500' :
            entry.status === 'missed' ? 'bg-red-500' : 'bg-slate-400'
          }`} />
        )}
      </div>
      <p className="font-medium truncate">{entry.client_name || 'Client'}</p>
      <p className="text-[10px] opacity-75 truncate">
        <User className="w-3 h-3 inline mr-1" />
        {entry.staff_name || 'Staff'}
      </p>
    </div>
  );
}
